import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

export interface NeighborhoodScores {
    walk_score: number | null;
    walk_description: string | null;
    transit_score: number | null;
    bike_score: number | null;
    school_count: number | null;
    school_score: number | null;
    school_grade: string | null;
    school_types: string[] | null;
    schools: Array<{ name: string; type: string; grades: string }> | null;
    safety_index: number | null;
    crime_grade: string | null;
    total_crimes: number | null;
    violent_crime_pct: number | null;
    crime_trend: 'improving' | 'stable' | 'declining' | null;
    median_income: number | null;
    poverty_rate: number | null;
    college_degree_rate: number | null;
    data_freshness: string | null;
    data_completeness: number | null;
}

export function useNeighborhoodScores(propertyId: string) {
    return useQuery<NeighborhoodScores>({
        queryKey: ['neighborhood', propertyId],
        queryFn: async () => {
            const { data } = await api.get<NeighborhoodScores>(
                `/property/${propertyId}/neighborhood`
            );
            return data;
        },
        enabled: !!propertyId,
        staleTime: 10 * 60 * 1000,
    });
}
